/** @format */

import React, { useState, useRef, useEffect } from "react";
import { Input, Form } from "antd";
import { IUsers } from "../../AccountInfoPage.types";

interface IEditableFirstNameProps {
	firstName: string;
	editedUsers: IUsers[];
	userId: string;
	setTheEditedUsers: (editedUsersList) => void;
	setIfUsersWereEdited: (value) => void;
	changesWereUndone: boolean;
	setUndoChanges: (value) => void;
}

const EditableFirstName: React.FC<IEditableFirstNameProps> = ({
	firstName,
	editedUsers,
	userId,
	setTheEditedUsers,
	setIfUsersWereEdited,
	changesWereUndone,
	setUndoChanges,
}) => {
	const [changedFirstName, setChangedFirstName] = useState<string>(firstName);
	const [isEditingFirstName, setIsEditingFirstName] = useState<boolean>(false);

	//Close editing mode when clicked outside of input area
	const node: any = useRef();
	useEffect(() => {
		const handleOnClickEditingMode = (e) => {
			if (node.current.contains(e.target)) {
				return;
			}
			if (changedFirstName.length > 0) {
				setIsEditingFirstName(false);
				setIfUsersWereEdited(true);
				const mappedEditedUsers = editedUsers.map((user) => {
					if (user.userId === userId) {
						user = { ...user, firstName: changedFirstName, isEdited: true };
					}
					return user;
				});
				setTheEditedUsers(mappedEditedUsers);
			}
		};

		if (isEditingFirstName) {
			document.addEventListener("mousedown", handleOnClickEditingMode);
		} else {
			document.removeEventListener("mousedown", handleOnClickEditingMode);
		}

		return () => {
			document.removeEventListener("mousedown", handleOnClickEditingMode);
		};
	}, [
		isEditingFirstName,
		changedFirstName,
		editedUsers,
		firstName,
		setTheEditedUsers,
		userId,
		setIfUsersWereEdited,
	]);

	const handleOnClickEditing = () => {
		setIsEditingFirstName(true);
		setUndoChanges(false);
	};

	const handleOnChangeInput = (e) => {
		setChangedFirstName(e.target.value);
	};

	const handleErrorValidation = () => {
		if (changedFirstName.length <= 0) {
			return "error";
		} else if (changedFirstName.length > 0) {
			return "";
		}
	};

	const handleErrorValidationMessage = () => {
		if (changedFirstName.length <= 0) {
			return "Please input a last name.";
		} else if (changedFirstName.length > 0) {
			return "";
		}
	};

	useEffect(() => {
		if (changesWereUndone) {
			setChangedFirstName(firstName);
		}
	}, [changesWereUndone, firstName]);

	return (
		<div
			className="editable-cell-value-wrapper"
			ref={node}
			onClick={handleOnClickEditing}>
			{isEditingFirstName ? (
				<Form.Item
					validateStatus={handleErrorValidation()}
					help={handleErrorValidationMessage()}>
					<Input
						value={changedFirstName}
						onChange={handleOnChangeInput}
						style={{ width: "50%" }}
					/>
				</Form.Item>
			) : (
				changedFirstName
			)}
		</div>
	);
};

export default EditableFirstName;
